export default __webpack_public_path__ + "static/media/gs-persona-1.ed8ffe09.webp";